@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    @if (showFieldAsEdit) {
      <div>
        <div class="checkbox-list">
          @for (picklistValue of picklistValues; track picklistValue.uId) {
            <div
              class="mb-2">
              <label class="checkbox">
                <input
                  type="checkbox"
                  [value]="picklistValue.uId"
                  [name]="field.systemName"
                  [checked]="value.includes(picklistValue.uId)"
                  (change)="checkChange($event)"
                  class="mr-3" />
                {{ picklistValue.value }}
              </label>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="is-readonly">{{ selectedValue }}</div>
    }
  </div>
}
